module.exports = __webpack_public_path__ + "img/PRprinting2.8135d6f0.png";